import config from "src/config";
import http, { postWithBasicHeader } from "../services/apiServices";

export const saveSurveyApi = async (survey: any) => {
  return await postWithBasicHeader(config.BMCCompany.saveSurvey, survey);
};
